import { Box } from '@mui/material';

import { useAuth } from '@client/context/auth/AuthContext';

import { LoadingSpinner } from '@app/frontend/components/layout/LoadingSpinner';
import Maintenance from '@app/frontend/components/Maintenance';

import { useClientBrowser } from '../hooks/useClientBrowser';
import { useFeatureFlags } from '../hooks/useFeatureFlags';
import Navigation from './navigation';
import VerifyEmailBanner from './navigation/components/VerifyEmailBanner';

export default ({ children }: { children: React.ReactNode }) => {
  const { isMobile } = useClientBrowser();

  const { user } = useAuth();
  const featureFlags = useFeatureFlags(user?.uid);

  const maintenanceModeEnabled = featureFlags?.maintenanceModeEnabled;
  const overrideMaintenanceMode = featureFlags?.overrideMaintenanceMode;
  const isLoading = featureFlags?.isLoading;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (maintenanceModeEnabled && !overrideMaintenanceMode) {
    return <Maintenance />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        width: '100%',
        minHeight: '100vh',
      }}>
      <Navigation />
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          pb: 4,
          pt: { xs: 10, md: 2 },
          px: isMobile ? 1 : 3,
          overflowX: 'auto',
        }}>
        <VerifyEmailBanner />

        {children}
      </Box>
    </Box>
  );
};
